import {Newsletter, NewsletterTemplate, NewsletterTemplateTimeZoneState} from "models"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import memo from "set-state-compare/src/memo"
import Nav from "./nav"
import NewsletterTemplateTimeZoneStatesTable from "components/newsletter-time-zone-states/table"
import {useAdminLayout} from "components/admin/layout"
import useModel from "@kaspernj/api-maker/build/use-model"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminNewsletterTemplatesNewsletters extends ShapeComponent {
  setup() {
    const {newsletterTemplate, newsletterTemplateId} = useModel(NewsletterTemplate, {
      match: this.p.match,
      select: {
        NewsletterTemplate: ["id"]
      }
    })

    const query = useMemo(() => NewsletterTemplateTimeZoneState.ransack({newsletter_template_id_eq: newsletterTemplateId}), [newsletterTemplateId])

    this.setInstance({newsletterTemplate, query})
    useAdminLayout()?.setState({active: "newsletter-templates", headerTitle: Newsletter.modelName().human({count: 2})})
  }

  render() {
    const {newsletterTemplate, query} = this.tt

    return (
      <View dataSet={{route: "admin-newsletter-templates/newsletter-time-zone-states"}}>
        {newsletterTemplate &&
          <Nav active="newsletter-time-zone-states" className="mb-4" newsletterTemplate={newsletterTemplate} />
        }
        <NewsletterTemplateTimeZoneStatesTable adminLayout collection={query} />
      </View>
    )
  }
}))
